import { doRequest, managerApiInstance } from 'clients/api';

const legalIdentityRequests = {
    listLegalIdentityType: async () =>
        doRequest<any>(managerApiInstance.post(`/legal-identity-type/listLegalIdentityType`)),
};

export { legalIdentityRequests };
